<template>
  <div id="main-content" class="place-list">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-button type="success" @click="goToAddAdminNotiTemplate()">+ {{ this.$t('notification.add_notification_template') }}</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <el-row style="padding-top: 20px">
        <table class="bus-list">
          <tr>
            <th>#</th>
            <th>{{ $t('common.title') }}</th>
            <th>{{ $t('common.content') }}</th>
            <th></th>
          </tr>
          <tr v-for="(template, index) in sortedAdminNotificationTemplateList" :key="template.id"
              v-show="index >= itemPerPage * (page - 1) && index < itemPerPage * page">
            <td width="5%">{{ index + 1 }}</td>
            <td width="40%">{{ template.title }}</td>
            <td width="40%">{{ template.content }}</td>
            <td>
              <b-button variant="outline-primary" @click="goToDetailAdminNotiTemplate(template.id)"
                        style="margin-right: 10px">{{ $t('common.detail') }}
              </b-button>
              <b-button variant="danger" @click="deleteAdminNotiTemplate(template.id, index)">
                {{ $t('common.delete') }}
              </b-button>
            </td>
          </tr>
        </table>
      </el-row>
      <el-row style="padding-top: 15px">
        <el-pagination
            v-show="sortedAdminNotificationTemplateList.length > itemPerPage"
            background
            @current-change="didSelectPage"
            :page-size="itemPerPage"
            layout="prev, pager, next"
            :current-page="page"
            :total="sortedAdminNotificationTemplateList.length">
        </el-pagination>
      </el-row>
    </el-col>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import { ITEM_PER_PAGE } from '@/config'
  import PageTitle from '@/components/PageTitle'

  export default {
    name: 'ListAdminNotificationTemplate',
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: ``,
        title: 'notification.admin_notification_template_list',
        page: 1,
        itemPerPage: ITEM_PER_PAGE
      }
    },
    methods: {
      goToAddAdminNotiTemplate: function () {
        this.saveState()
        this.$router.push('/admin-notification-template/add')
      },
      goToDetailAdminNotiTemplate(templateId) {
        this.saveState()
        this.$router.push({path: '/admin-notification-template/detail', query: {tid: templateId}});
      },
      saveState: function () {
        this.$store.commit('adminnotification/saveState', {
          page: this.page
        })
      },
      didSelectPage: function (e) {
        this.page = e
      },
      deleteAdminNotiTemplate(templateId, index) {
        this.$store.commit('openConfirm', {
          title: this.$t('common.delete'),
          message: this.$t('notification.template_delete_confirm'),
          callback: () => {
            let payload = {
              admin_notification_template_id: templateId,
              index: index
            }

            this.$store.dispatch('adminnotification/deleteAdminNotificationTemplate', payload)
            if (index == this.sortedAdminNotificationTemplateList.length - 1){
              let pageNumber = (this.sortedAdminNotificationTemplateList.length -1 ) / this.itemPerPage
              this.page = Math.ceil(pageNumber)
            }
          }
        })
      }
    },
    mounted: function () {
      this.$store.dispatch('adminnotification/retrieveAdminNotificationTemplateList', {})
    },
    computed: {
      ...mapState('adminnotification', ['adminNotificationTemplateList', 'currentPage']),
      sortedAdminNotificationTemplateList: function () {
        let sortedAdminNotificationTemplateList = [].concat(this.adminNotificationTemplateList)

        sortedAdminNotificationTemplateList.sort((before, after) => {
          return before.id < after.id ? 1 : -1
        })

        return sortedAdminNotificationTemplateList
      }
    },
    created: function () {
      if (this.$route.query.action && this.$route.query.action === "back") {
        if (this.currentPage) {
          this.page = this.currentPage
        }

        this.isBack = true
      }

      this.$store.commit('notification/updateAdminNotificationState', {
        page: null
      })
    }
  }
</script>
<style lang="scss">
  .bus-list {
    width: 100%;
    /*border: 1px solid #DCDFE6;*/
  }

  table, th, td {
    border: 1px solid #DCDFE6;
    border-collapse: collapse;
  }

  th {
    height: 55px;
    background-color: rgba(0, 0, 0, 0.2);
    color: #fff;
  }

  td {
    height: 40px;
  }
</style>